import { render, staticRenderFns } from "./EnvPage.vue?vue&type=template&id=53f8f4ae&scoped=true&"
import script from "./EnvPage.vue?vue&type=script&lang=js&"
export * from "./EnvPage.vue?vue&type=script&lang=js&"
import style0 from "./EnvPage.vue?vue&type=style&index=0&id=53f8f4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f8f4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f8f4ae')) {
      api.createRecord('53f8f4ae', component.options)
    } else {
      api.reload('53f8f4ae', component.options)
    }
    module.hot.accept("./EnvPage.vue?vue&type=template&id=53f8f4ae&scoped=true&", function () {
      api.rerender('53f8f4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/EnvPage.vue"
export default component.exports